import { observer } from 'mobx-react';
import OutreachDesktop from './desktop/OutreachDesktop';
import { useEffect } from 'react';

const Outreach = observer(() => {
  useEffect(() => {
    document.title = `transact.digital GmbH - Outreach center`;
  }, []);

  return <OutreachDesktop />;
});

export default Outreach;
